module.exports = __webpack_public_path__ + "img/pig.a9630352.jpeg";